import {
  logoHeader,
  logoHeaderDialog,
  logoHeaderText,
} from '@mage-ui/styled-system/recipes';
import { LogoSymbol } from './LogoSymbol';
import { LogoWrapper } from './LogoWrapper';

export const LogoEoiHeader = (props) => {
  return (
    <LogoWrapper className={logoHeader()} {...props}>
      <LogoSymbol
        className={logoHeaderDialog()}
        title='Logo Header Dialog EOI'
        symbol='logo-header-dialog-eoi'
        viewBox='0 0 61 61'
      />
      <LogoSymbol
        className={logoHeaderText()}
        title='Logo Header Text EOI'
        symbol='logo-txt-eoi'
        viewBox='0 0 80 23'
      />
    </LogoWrapper>
  );
};
